import styled from 'styled-components';
import HeaderInformation from '../../../../HeaderInformation';

const StyledUserInfo = styled(HeaderInformation)`
  padding: 24px 0;
`;

export {StyledUserInfo};
